import { type SanityBlogPostBody } from '@data/sanity/queries/types/blog'

import ComplexPortableText from '@components/complex-portable-text'

type BlogPostBodyProps = Pick<SanityBlogPostBody, 'content'>

const BlogPostBody = ({ content }: BlogPostBodyProps) => {
  return (
    <section className="container flex flex-col justify-center items-center mb-12">
      <div className="rc rc-blog-post before:content-[''] before:block before:mb-12 before:lg:mb-20">
        <ComplexPortableText content={content} />
      </div>
    </section>
  )
}

export default BlogPostBody
